import * as models from 'smg/customer-api/models';
import { SearchSitePages, SearchText } from 'smg/customer-api/v2/sites';
import { ShowError } from 'smg/errors';
import QueryString from 'smg/querystring';

void main();

async function main() {
    const query = QueryString().get('q') || '';
    // Update search inputs
    document.querySelectorAll<HTMLInputElement>('input[type="search"]').forEach(input => input.value = query);

    if (!query.trim()) {
        showInitialState();
        return;
    }

    try {
        const results = await SearchSitePages({
            q: SearchText(query),
            data: 'title,url,type,highlightedSummary,tags,images,date,params',
        });
        displayResults(results, query);
    } catch (error) {
        ShowError(error);
        showNoResults();
    }
}

function displayResults(results: models.SitePage[], query: string) {
    const $spinner = document.getElementById('search-spinner');
    const $resultsContainer = document.getElementById('search-results');
    const $pageContainer = document.getElementById('results-container');
    const $blogContainer = document.getElementById('blog-results-container');

    // Hide spinner, show results
    $spinner?.classList.add('d-none');
    $resultsContainer?.classList.remove('d-none');

    // Update counts and terms
    document.querySelectorAll('.search-count').forEach(el => el.textContent = results.length.toLocaleString());
    document.querySelectorAll('.search-term').forEach(el => el.textContent = query);

    if (results.length === 0) {
        showNoResults();
        return;
    }

    if ($pageContainer) {
        $pageContainer.innerHTML = '';
    }
    if ($blogContainer) {
        $blogContainer.innerHTML = '';
    }
    document.getElementById('page-results-section')?.classList.add('d-none');
    document.getElementById('blog-results-section')?.classList.add('d-none');

    const blogResults: models.SitePage[] = [];
    const pageResults: models.SitePage[] = [];
    for (const result of results) {
        if (result.type === 'blog' && result.url !== '/blog/') {
            blogResults.push(result);
        } else {
            pageResults.push(result);
        }
    }

    const $template = document.getElementById('search-result-template') as HTMLTemplateElement;
    if (pageResults.length > 0 && $pageContainer && $template) {
        const $pageSection = document.getElementById('page-results-section');
        $pageSection?.classList.remove('d-none');

        for (const result of pageResults) {
            const $result = $template.content.cloneNode(true) as DocumentFragment;

            const $link = $result.querySelector('.result-link') as HTMLAnchorElement;
            $link.href = result.url;
            $link.textContent = result.title;

            const $snippet = $result.querySelector('.result-snippet') as HTMLElement;
            $snippet.innerHTML = result.highlightedSummary;

            const $btn = $result.querySelector('.read-more-button') as HTMLAnchorElement;
            $btn.href = result.url;

            $pageContainer.appendChild($result);
        }
    }

    const $blogTemplate = document.getElementById('blog-result-template') as HTMLTemplateElement;
    if (blogResults.length > 0 && $blogContainer && $blogTemplate) {
        const $blogSection = document.getElementById('blog-results-section');
        $blogSection?.classList.remove('d-none');

        const logoSrc = document.getElementById('logo-placeholder')?.dataset.src || '';

        for (const result of blogResults) {
            const $result = $blogTemplate.content.cloneNode(true) as DocumentFragment;

            const $tags = $result.querySelector('.blog-result-tags') as HTMLElement;
            if (result.tags.length > 0) {
                for (const tag of result.tags) {
                    const $tag = document.createElement('a');
                    $tag.href = tag.relPermalink;
                    $tag.textContent = tag.title;
                    $tag.classList.add('badge', 'text-dark', 'text-decoration-none', 'text-capitalize', 'small');
                    $tag.style.backgroundColor = '#e9ecef';
                    $tags.appendChild($tag);
                }
            } else {
                $tags.classList.add('d-none');
            }

            const $link = $result.querySelector('.result-link') as HTMLAnchorElement;
            $link.href = result.url;
            $link.textContent = result.title;

            const $imgLink = $result.querySelector('.blog-result-image-link') as HTMLAnchorElement;
            $imgLink.href = result.url;

            const $img = $result.querySelector('.blog-result-image') as HTMLImageElement;
            $img.src = result.images[0] || logoSrc;
            $img.alt = result.title;
            if (!result.images[0] && logoSrc) {
                $img.style.objectFit = 'contain';
            }

            const $date = $result.querySelector('.blog-result-date') as HTMLElement;
            if (result.date.isValid) {
                $date.textContent = result.date.toJSDate().toLocaleDateString('en-US', {
                    month: 'long',
                    day: 'numeric',
                    year: 'numeric',
                    timeZone: 'UTC',
                });
            }

            const $readTime = $result.querySelector('.blog-result-read-time') as HTMLElement;
            let hasReadTime = false;
            if (result.params.readingduration) {
                const match = /^(\d+)m/.exec(result.params.readingduration);
                if (match) {
                    $readTime.textContent = `${match[1]} min read`;
                    hasReadTime = true;
                }
            }

            const $separator = $result.querySelector('.blog-result-separator') as HTMLElement;
            if (!result.date || !hasReadTime) {
                $separator.classList.add('d-none');
                $separator.classList.remove('d-sm-inline');
            }

            const $snippet = $result.querySelector('.result-snippet') as HTMLElement;
            $snippet.innerHTML = result.highlightedSummary;

            const $btn = $result.querySelector('.read-more-button') as HTMLAnchorElement;
            $btn.href = result.url;

            $blogContainer.appendChild($result);
        }
    }
}

function showNoResults() {
    document.getElementById('search-spinner')?.classList.add('d-none');
    document.getElementById('search-results')?.classList.add('d-none');
    document.getElementById('initial-state')?.classList.add('d-none');
    document.getElementById('no-results')?.classList.remove('d-none');
}

function showInitialState() {
    document.getElementById('search-spinner')?.classList.add('d-none');
    document.getElementById('search-results')?.classList.add('d-none');
    document.getElementById('no-results')?.classList.add('d-none');
    document.getElementById('initial-state')?.classList.remove('d-none');
}

const clearSearchBtn = document.getElementById('clear-search-btn');
if (clearSearchBtn) {
    clearSearchBtn.addEventListener('click', () => {
        const input = document.querySelector('input[type="search"]') as HTMLInputElement;
        if (input) {
            input.value = '';
            input.focus();
        }
        showInitialState();
    });
}
